jQuery(document).ready(function($) {

	//! Testimonials slider !//

		$(".testimonials__item").slick({
			adaptiveHeight: true,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: false,
			draggable: false,
			nextArrow: '<button class="slick-arrow slick-arrow-next"><svg width="164" height="94" viewBox="0 0 164 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M120.806 0.0414429C120.806 26.0199 139.718 47.0208 163.093 47.0208C139.718 47.0208 120.806 68.0218 120.806 94" stroke="#FA6E47" stroke-width="4" stroke-miterlimit="10"/><line x1="163" y1="47.4413" y2="47.4413" stroke="#FA6E47" stroke-width="4"/></svg></button>',
			prevArrow: '<button class="slick-arrow slick-arrow-prev"><svg width="164" height="94" viewBox="0 0 164 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.2876 93.9586C42.2876 67.9801 23.3751 46.9792 0.000119525 46.9792C23.3751 46.9792 42.2876 25.9782 42.2876 -2.04305e-06" stroke="#FA6E47" stroke-width="4" stroke-miterlimit="10"/><line x1="0.0932619" y1="46.9586" x2="163.093" y2="46.9586" stroke="#FA6E47" stroke-width="4"/></svg></button>',
			speed: 700,
			responsive: [
				{
					breakpoint: 769,
					settings: {
						arrows: false,
						dots: true
					}
				}
			]
		});

	//!  !//

	//! Instafeed slider !//

		var destroy = true;
	
		function instSlider() {
			if($(window).width() < 641 && destroy) {
				$(".insta-feed-slider").not(".slick-initialized").slick({
					arrows: false,
					autoplay: true,
					autoplaySpeed: 4000,
					centerMode: true,
					dots: false,
					outerEdgeLimit: true,
					slidesToShow: 1,
					speed: 700,
					variableWidth: true
				});

				destroy = false;
			} else if($(window).width() > 640 && !destroy) {
				$(".insta-feed-slider").slick("unslick");

				destroy = true;
			}
		}

		var instLoader = setInterval(function() {
			if($("#insta-feed > a").length > 0) {
				$("#insta-feed > a").each(function() {
					var img = $(this).find("img");

					img.attr("src", img.attr("data-src"));
				});

				$("#insta-feed > a").wrapAll('<div class="insta-feed-slider"></div>');

				instSlider();

				clearInterval(instLoader);
			}
		});

	//!  !//

	//! Shop titles !//

		$($(".product-grid-container").parents(".shopify-section").prevAll(".section-title, .section-marquee").get().reverse()).each(function(i) {
			var titlesArray = Array.prototype.reverse.call($(this));

			titlesArray.insertAfter($(".product-grid-container .product-grid").eq(i));
		});

	//!  !//

	//! Product slider !//

		$(".product__slider-list").slick({
			arrows: true,
			dots: false,
			nextArrow: '<button class="slick-arrow slick-arrow-next"><svg width="164" height="94" viewBox="0 0 164 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M120.899 0C120.899 25.9784 139.812 46.9793 163.187 46.9793C139.812 46.9793 120.899 67.9804 120.899 93.9586" stroke="#C6D92D" stroke-width="4" stroke-miterlimit="10"/><line x1="163.094" y1="47.3999" x2="0.09375" y2="47.3999" stroke="#C6D92D" stroke-width="4"/></svg></button>',
			prevArrow: '<button class="slick-arrow slick-arrow-prev"><svg width="164" height="94" viewBox="0 0 164 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.2876 93.959C42.2876 67.9806 23.3751 46.9797 0.000119525 46.9797C23.3751 46.9797 42.2876 25.9786 42.2876 0.000425203" stroke="#C6D92D" stroke-width="4" stroke-miterlimit="10"/><line x1="0.0942385" y1="46.959" x2="163.094" y2="46.959" stroke="#C6D92D" stroke-width="4"/></svg></button>',
			speed: 700,
		});

	//!  !//

	//! Cart Drawer !//

		function cartDrawer() {
			var headerHeight = $(".header-wrapper").outerHeight(),
				announcementBarheight = $("#shopify-section-announcement-bar").outerHeight() || 0,
				windowHeight = window.innerHeight,
				scrolled = $(window).scrollTop();
				console.log(headerHeight);

			if(scrolled > headerHeight) {
				$("#cart-simple-drawer").css({
					height: windowHeight + "px",
					top: "0"
				});
			} else {
				$("#cart-simple-drawer").css({
					height: windowHeight + scrolled - headerHeight + "px",
					top: (headerHeight + announcementBarheight) - scrolled + "px"
				});
			}

		} cartDrawer();

		$(window).on("scroll", function() {
			cartDrawer();
		});

		$(".custom-header-cart").on("click", function() {
			$(".header__icon.header__icon--menu").trigger("click");
		});

	//!  !//

	//! Image carousel !//

		$(".ak-carousel-slides").slick({
			adaptiveHeight: true,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 4000,
			dots: false,
			nextArrow: '<button class="slick-arrow slick-arrow-next"><svg width="164" height="94" viewBox="0 0 164 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M120.806 0.0414429C120.806 26.0199 139.718 47.0208 163.093 47.0208C139.718 47.0208 120.806 68.0218 120.806 94" stroke="#FA6E47" stroke-width="4" stroke-miterlimit="10"/><line x1="163" y1="47.4413" y2="47.4413" stroke="#FA6E47" stroke-width="4"/></svg></button>',
			prevArrow: '<button class="slick-arrow slick-arrow-prev"><svg width="164" height="94" viewBox="0 0 164 94" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M42.2876 93.9586C42.2876 67.9801 23.3751 46.9792 0.000119525 46.9792C23.3751 46.9792 42.2876 25.9782 42.2876 -2.04305e-06" stroke="#FA6E47" stroke-width="4" stroke-miterlimit="10"/><line x1="0.0932619" y1="46.9586" x2="163.093" y2="46.9586" stroke="#FA6E47" stroke-width="4"/></svg></button>',
			speed: 700,
			responsive: [
				{
					breakpoint: 769,
					settings: {
						arrows: false
					}
				}
			]
		});

	//!  !//

	//! Resize !//

		$(window).on("resize", function() {
			instSlider();
			cartDrawer();
		});

	//!  !//

});